
function getFrameParams() {
  let url = window.location.href;
  let urlParams = url.slice(url.indexOf('?') + 1).split('&');
  let params = [];
  urlParams.forEach(element => {
    let datas = element.split('=');
    params[datas[0]] = datas[1];
  });
  return params;
}
module.exports = getFrameParams



// WEBPACK FOOTER //
// ./ecology9/wea-tools/getUrlParams.js